import { createContext } from 'react';

const WindowContext = createContext<any>(null);

export default WindowContext;
